import { render, staticRenderFns } from "./RolesWrapper.vue?vue&type=template&id=4a3aa5bc"
import script from "./RolesWrapper.vue?vue&type=script&lang=js"
export * from "./RolesWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports